/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-work-body{max-height:calc(100% - 100px)!important;overflow-y:hidden!important}.ag-header-cell-text{-webkit-box-flex:1!important;flex:1!important}.ag-cell{padding-left:2px!important;padding-right:2px!important}.text-center{text-align:center!important}.mat-drawer-inner-container{overflow:hidden!important}"];
export { styles as styles };
